export default __webpack_public_path__ + "static/social-def0feef0897eed173fc6e553a176997.jpg";